import { Channel } from "@/types";
import {
  Creative,
  CreativeByChannel,
  DisplayCreative,
  LinkedinCreative,
} from "./asset.interface";

export function isDisplayCreatives(
  row: Creative<Channel>
): row is Creative<"display"> {
  return row.channel === "display";
}
export function isDisplayCreative(
  creative: CreativeByChannel<Channel>
): creative is DisplayCreative {
  return "adId" in creative;
}

export function isLinkedinCreatives(
  row: Creative<Channel>
): row is Creative<"linkedin"> {
  return row.channel === "linkedin";
}

export function isLinkedinCreative(
  creative: CreativeByChannel<Channel>
): creative is LinkedinCreative {
  return "linkedinAssetUrn" in creative;
}
